import { Input } from 'reactstrap';

export const notIncludedStatus = ['SUBMITTED', 'OFFERED', 'PLACED'];

/** Pending-interview ids of an INTERVIEWED applicant (what its checkbox puts into the selection). */
export const pendingInterviewIdsOf = (item: any): string[] =>
  (item?.interviews || [])
    .filter((interview: any) => interview?.InterviewState === 'PENDING')
    .map((interview: any) => interview.id);

/**
 * Mirrors the row checkbox's `disabled` rule so "Select all on this page" (kan-116)
 * picks exactly the rows a user could tick by hand:
 *  - SUBMITTED / OFFERED / PLACED are never selectable;
 *  - INTERVIEWED is selectable only while it has a pending interview;
 *  - everything else is selectable unless its submission is COMPLETED.
 */
export const isApplicantSelectable = (item: any): boolean => {
  const status = item?.JobAppStatus;
  if (notIncludedStatus.includes(status)) return false;
  if (status === 'INTERVIEWED') return pendingInterviewIdsOf(item).length > 0;
  return item?.submission?.status !== 'COMPLETED';
};

/** The selection entry a non-INTERVIEWED row contributes to `actionData`. */
export const buildSelectionEntry = (item: any) => ({
  userId: item?.id,
  url:
    item?.candidate?.emails?.find((email: any) => email.isPrimary)?.email ||
    item?.candidate?.linkedInUrl,
  name: item?.candidate?.fullName,
  jobTitle: item?.candidate?.idealJobTitle,
  employment: item?.candidate?.employmentHistory,
  candidateId: item?.candidate?.id,
});

/** Whether a row currently counts as selected, given the mixed-shape `actionData`. */
export const isApplicantSelected = (item: any, actionData: any[]): boolean => {
  if (item?.JobAppStatus === 'INTERVIEWED') {
    const ids = pendingInterviewIdsOf(item);
    return ids.length > 0 && ids.every((id) => actionData.includes(id));
  }
  return actionData.some((entry) => entry && typeof entry === 'object' && entry.userId === item?.id);
};

export const CheckJobApplicantComponent = ({
  item,
  actionData,
  setActionData,
  forInterview
}) => {
  const handleCheckBox = (e, item: any) => {
    if (item?.JobAppStatus !== "INTERVIEWED") {
      const itemId = item?.id;
      const userData = [...actionData];
      if (e.target.checked) {
        let data = userData?.filter((val) => val?.userId !== itemId && val);
        setActionData([...data, buildSelectionEntry(item)]);
      } else {
        const usersData = [...actionData];
        // eslint-disable-next-line
        const itemIndex = usersData.findIndex((el) => {
          if (el?.userId === itemId) {
            return el;
          }
        });

        usersData.splice(itemIndex, 1);

        setActionData(usersData);
      }
    } else {
      const pendingInterviewIds = pendingInterviewIdsOf(item);
      if (e.target.checked) {
        setActionData([...actionData, ...pendingInterviewIds]);
      } else {
        const pendingInterviewData = [...actionData];
        pendingInterviewIds.forEach(id => {
          const itemIndex = pendingInterviewData.indexOf(id);
          pendingInterviewData.splice(itemIndex, 1);
        });
        setActionData(pendingInterviewData);
      }
    }
  };

  return (
    <div>
      <Input
        type="checkbox"
        // Controlled so "Select all on this page" is reflected in every row.
        checked={isApplicantSelected(item, actionData)}
        onChange={(e) => handleCheckBox(e, item)}
        disabled={notIncludedStatus.includes(item?.JobAppStatus) || forInterview || (item?.JobAppStatus !== 'INTERVIEWED' && item?.submission?.status === 'COMPLETED')}
      />
    </div>
  );
};
